/**
 * Servicio de Cartografía y APIs de Esri ArcGIS
 * Clave API oficial transferida desde el entorno SMTPC-LAB
 */

export const ARCGIS_API_KEY = "AAPTaynOzCr5gjVCnAHw9vRlaKQ..zUDNj04JZSY-2MbEyirVR8MGZ-DLOLyoZEZyWFt2mF_DuKquH97pcM8aUwh7zGDLc71W59iFA-RarkO5QIEDHE8HdJ_w4c7WzxwWKSnP_JC9OXk2vyVwuTwaE0m_fi-BwqsK550bgIba-kSgzYcOlpWSErxBIHaNWrv3RD5j2ZkQqoUWQ3hQo6sGF6H9vGNWOBvgYa28xVGFRr66c3q72OyPXnc03F0d-3dU7HXnQloE18RhKPLh8CaV7Q..AT1_brofOgr5";

export type ArcgisBasemapType = 'imagery' | 'hybrid' | 'topographic' | 'streets' | 'wayback';

export interface ArcgisLayerConfig {
  url: string;
  attribution: string;
  maxZoom: number;
  label: string;
}

export const ARCGIS_WAYBACK_RELEASES: Record<string, { release: string; label: string }> = {
  '2014': { release: '5844', label: 'Año 2014' },
  '2017': { release: '19000', label: 'Año 2017' },
  '2020': { release: '29260', label: 'Año 2020' },
  '2023': { release: '16453', label: 'Año 2023' },
  '2026': { release: '10842', label: 'Año 2026 (Actual)' }
};

export const ARCGIS_BASEMAPS: Record<Exclude<ArcgisBasemapType, 'wayback'>, ArcgisLayerConfig> = {
  imagery: {
    url: `https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}?token=${ARCGIS_API_KEY}`,
    attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP',
    maxZoom: 19,
    label: 'Satélite HD (ArcGIS)'
  },
  hybrid: {
    url: `https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}?token=${ARCGIS_API_KEY}`,
    attribution: 'Tiles &copy; Esri &mdash; Esri World Imagery with Reference',
    maxZoom: 19,
    label: 'Satélite Híbrido (ArcGIS)'
  },
  topographic: {
    url: `https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}?token=${ARCGIS_API_KEY}`,
    attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN',
    maxZoom: 19,
    label: 'Topográfico (ArcGIS)'
  },
  streets: {
    // OpenStreetMap / Carto con cobertura 100% en Busan, El Raval y Yungay
    url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
    attribution: '&copy; OpenStreetMap contributors &copy; CARTO &copy; Esri Community',
    maxZoom: 19,
    label: 'Morfología Urbana (Calles)'
  }
};

export function getWaybackUrl(year: string): string {
  const rel = ARCGIS_WAYBACK_RELEASES[year] || ARCGIS_WAYBACK_RELEASES['2026'];
  return `https://wayback.maptiles.arcgis.com/arcgis/rest/services/world_imagery/mapserver/tile/${rel.release}/{z}/{y}/{x}`;
}

/**
 * Cálculo de ruta y transecto espacial mediante ArcGIS Route Server
 */
export async function solveArcgisRoute(startCoords: [number, number], endCoords: [number, number]) {
  const start = `${startCoords[1]},${startCoords[0]}`; // lon,lat
  const end = `${endCoords[1]},${endCoords[0]}`;
  const url = `https://route-api.arcgis.com/arcgis/rest/services/World/Route/NAServer/Route_World/solve?token=${ARCGIS_API_KEY}&stops=${start};${end}&f=json`;

  const res = await fetch(url);
  if (!res.ok) throw new Error('Error al resolver ruta en ArcGIS REST API');
  return res.json();
}
